<template>
    <v-row>
        <!-- <v-col cols="12" md="4" class="pt-1 pb-4">
            <v-select :items="monthList" v-model="showMonth" hide-details dense @change="updateMonth"></v-select>
        </v-col>
        <v-col cols="12" md="4" class="pt-1 pb-4">
            <v-select :items="yearList" v-model="showYear" hide-details dense @change="updateYear"></v-select>
        </v-col> -->
        <v-col cols="6" sm="12" md="12" class="">
            <span class="subtitle-1 font-weight-bold">{{showMonth}}</span>
            &nbsp;
            <span class="subtitle-1 font-weight-bold">{{showYear}}</span>
        </v-col>
        <v-col class="hidden-md-and-up text-right py-0" cols="6" sm="12">
            <v-btn icon :disabled="canGoBack()" small @click="prevWeek()" large class=" mr-3"
                   style="font-size: 13px">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon :disabled="canGoAhead()" small @click="nextWeek()" large class=""
                   style="font-size: 13px">
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" class="">
            <v-row align="center" justify="space-between" class="px-2">
                <v-col class="hidden-sm-and-down">
                    <v-btn icon :disabled="canGoBack()" small @click="prevWeek()" large class="mt-4"
                           style="font-size: 13px">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                </v-col>
                <v-col class="subtitle-2 pb-1 px-1 text-center" v-for="(n, i) in loopDays" :key="i">
				
                    <div v-if="isToday(showWeekStartDay + i)" style="font-size: 12px; height: 22px; font-weight: bold;">
                        Today
                    </div>
                    <div v-else style="font-size: 8px; height: 22px;" class="pb-1"></div>
                    <!--                    <div-->
                    <!--                            @click="selectDate(showWeekStartDay + i)"-->
                    <!--                            :class="((showWeekStartDay + i) === selectedDay ? 'selected-date':'') + ' all-dates mt-1'"-->
                    <!--                    >-->
                    <!--                        {{showDayName(showWeekStartDay + i)}}-->
                    <!--                        <br>-->
                    <!--                        {{showDayNumber(showWeekStartDay + i)}}-->
                    <!--                    </div>-->
                    <v-btn icon
                           :class="(isSameDay(showWeekStart.clone().add(i,'days')) ? 'accent white--text':'') + ' mt-1 date-buttons'"
                           large style="font-size: 13px" @click="selectDate(showWeekStart.clone().add(i,'days'))">
                        {{ showWeekStart.clone().add(i,'days').format('ddd') }}
                        <br>
                        {{ showWeekStart.clone().add(i,'days').format('D') }}
                    </v-btn>
                </v-col>
                <v-col  class="hidden-sm-and-down">
                    <v-btn icon :disabled="canGoAhead()" small @click="nextWeek()" large class="mt-4"
                           style="font-size: 13px">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
    export default {
        name: "DatePicker",
        watch: {},
        props: ['default_date'],
        methods: {
			isSameDay(value){
				
                return value.format('YYYY-MM-DD') == this.returnDate
			},
            showDayName(value) {
                let year = this === undefined ? this.moment().format('YYYY') + '-01-01 00:00:00' : this.showYear + '-01-01 00:00:00'
				
                return this.moment(year).dayOfYear(value).format('ddd')
            },
            showDayNumber(value) {
                let year = this === undefined ? this.moment().format('YYYY') + '-01-01 00:00:00' : this.showYear + '-01-01 00:00:00'
				
                return this.moment(year).dayOfYear(value).format('D')
            },
            isToday(dayNo) {
                return this.moment(this.showYear).dayOfYear(dayNo).format('YYYY-MM-DD') === this.today.format('YYYY-MM-DD')
            },
            updateMonth() {
                let monthNumber = this.moment().month(this.showMonth).format("MM")
                if (this.todayMonthNumber >= monthNumber) {
                    this.showWeekStart = this.moment(this.yearList[0] + '-' + monthNumber + '-01').startOf('week')
                } else {
                    this.showWeekStart = this.moment(this.yearList[1] + '-' + monthNumber + '-01').startOf('week')
                }
                if (this.showWeekStart.format('D') !== '1') {
                    this.showWeekStart.add(1, 'week')
                }
                this.updateCalendar()
            },
            updateYear() {
                this.showWeekStart = this.moment(this.showYear + '-01-01') < this.minWeekStart ? this.minWeekStart : this.moment(this.showYear + '-01-01').startOf('week')
                if (this.showWeekStart.format('D') !== '1' && this.showWeekStart !== this.minWeekStart) {
                    this.showWeekStart.add(1, 'week')
                }
                this.updateCalendar()
            },
            selectDate(value) {
                let date = value.clone()
                if (date >= this.minWeekStart) {
                    if (this.today <= date) {
                        this.selectedDay = value
                        this.returnDate = date.format('YYYY-MM-DD')
                    }
                } else {
                    this.selectedDay = value
                    date = this.moment(this.yearList[1]).dayOfYear(value)
                    this.returnDate = date.format('YYYY-MM-DD')
                }
                this.$emit('input', this.returnDate)
            },
            canGoAhead() {
                let toDate = this.moment(this.showYear + '-01-01 00:00:00').dayOfYear(this.showWeekStartDay)
                return !(this.maxWeekStart > toDate.add(this.loopDays, 'days'))
            },
            canGoBack() {
                let toDate = this.moment(this.showYear + '-01-01 00:00:00').dayOfYear(this.showWeekStartDay)
				
                return !(this.minWeekStart <= toDate.subtract(this.loopDays, 'days'))
            },
            nextWeek() {
                this.showWeekStart.add(this.loopDays, 'days')
                this.updateCalendar()
            },
            prevWeek() {
                this.showWeekStart.subtract(this.loopDays, 'days')
                this.updateCalendar()
            },
            updateCalendar() {
                this.showWeekStartDay = this.showWeekStart.dayOfYear()
                this.showMonth = this.showWeekStart.format('MMMM')
                this.showYear = this.showWeekStart.format('YYYY')
            },
            setDefaultDates() {
                 var cur_moment=this.moment()
                 if(this.default_date != undefined){                    
                     cur_moment = this.moment(this.default_date,"YYYY-MM-DD")
					 
					 this.selectedDay = cur_moment.dayOfYear();
					 
                 }
                
                //this.selectedDay = this.moment().dayOfYear();
                
                this.todayMonthNumber = this.moment().format("M");
                var today_moment = this.moment()
                this.today = today_moment.startOf('day');
                this.showMonth = cur_moment.format('MMMM');
                this.showYear = cur_moment.format('YYYY');
                this.showWeekStartDay = cur_moment.clone().startOf('week').dayOfYear();
                this.monthList = this.moment.months();
                this.yearList = [this.moment().format('YYYY'), this.moment().add(1, 'year').format('YYYY')];
                this.showWeekStart = cur_moment.clone().startOf('week');
                this.minWeekStart = this.moment().startOf('week');
                this.maxWeekStart = this.moment().add(11, 'months').endOf('month');
                this.returnDate = cur_moment.format('YYYY-MM-DD');
				this.$emit('input', this.returnDate)
				
                if (this.$vuetify.breakpoint.mdAndUp) {
                    this.loopDays = 7
                }
            }
        },
        data() {
            return {
                loopDays: 5,
                todayMonthNumber: null,
                selectedDay: null,
                today: null,
                showMonth: null,
                showYear: null,
                showWeekStartDay: null,
                monthList: null,
                yearList: null,
                showWeekStart: null,
                minWeekStart: null,
                maxWeekStart: null,
                returnDate: null,
            }
        },
        created() {
            this.setDefaultDates();
        },
        mounted() {
           
            this.showMonth = this.moment().dayOfYear(this.selectedDay).format('MMMM')
            let thisMonthIndex = this.monthList.indexOf(this.showMonth)
            if (thisMonthIndex > 0) {
                let x = this.monthList.splice(0, thisMonthIndex)
                this.monthList = this.monthList.concat(x)
            }
            this.$emit('input', this.returnDate)
        }
    }
</script>
<style scoped>
    .date-buttons {
        transition: 200ms all linear;
    }
</style>
